"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactActions = void 0;
var ArtifactActions;
exports.ArtifactActions = ArtifactActions;
(function (ArtifactActions) {
  ArtifactActions["ADD_ARTIFACT_MAPPING_PIPELINE"] = "AddArtifactMappingPipeline";
  ArtifactActions["ADD_ARTIFACT_MAPPING_REPO"] = "AddArtifactMappingRepo";
  ArtifactActions["DELETE_ARTIFACT_MAPPING_PIPELINE"] = "DeleteArtifactMappingPipeline";
  ArtifactActions["DELETE_ARTIFACT_MAPPING_REPO"] = "DeleteArtifactMappingRepo";
  ArtifactActions["SAVE_ARTIFACT_TAG_PIPELINE"] = "SaveArtifactTagPipeline";
  ArtifactActions["SAVE_ARTIFACT_TAG_REPO"] = "SaveArtifactTagRepo";
})(ArtifactActions || (exports.ArtifactActions = ArtifactActions = {}));